export default "__VITE_ASSET__BRl87D2M__"